import { useState, type FormEvent } from 'react';
import { Button } from '../../components/Button';
import { useSessionStore } from '../../stores/sessionStore';
import './login.css';

/** Login-Maske — Accounts werden von Admins angelegt, keine Registrierung. */
export function LoginScreen() {
  const { login, error } = useSessionStore();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  const onSubmit = async (event: FormEvent): Promise<void> => {
    event.preventDefault();
    setBusy(true);
    await login(username, password);
    setBusy(false);
  };

  return (
    <main className="login">
      <div className="login__panel">
        <div className="login__brand">
          <span className="login__dot" aria-hidden="true" />
          <h1 className="login__title">etown</h1>
        </div>
        <p className="login__subtitle">Dein virtuelles Büro. Lauf vorbei, sag hallo.</p>

        <form className="login__form" onSubmit={onSubmit}>
          <label className="login__field">
            <span>Benutzername</span>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              autoFocus
              required
            />
          </label>
          <label className="login__field">
            <span>Passwort</span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </label>
          {error && <p className="login__error" role="alert">{error}</p>}
          <Button type="submit" disabled={busy}>
            {busy ? 'Anmelden…' : 'Anmelden'}
          </Button>
        </form>

        <p className="login__hint">Kein Zugang? Frag eine Administratorin nach einem Account.</p>
      </div>
    </main>
  );
}
